import styled from "styled-components";
import {LiveCasinoGridDefaultBox} from "./live-casino-grid.default.box";

export const LiveCasinoGridCasino777Box = styled(LiveCasinoGridDefaultBox)`
    &:before {
        background-size: cover;
        top: 0;
        height: 35rem;

      @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        display: block;
        opacity:1;
      }
    }
`;
